export const Fulfilled = 'fulfilled'

export const Rejected = 'rejected'
